import { merge } from 'lodash-es';
import {
  ssnOrVaFileNumberNoHintSchema,
  ssnOrVaFileNumberNoHintUI,
  serviceNumberSchema,
  serviceNumberUI,
  textUI,
  titleUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../../../config/validations';
import content from '../../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['veteran-id-title'], content['veteran-id-description']),
    veteranSocialSecurityNumber: merge({}, ssnOrVaFileNumberNoHintUI(), {
      vaFileNumber: {
        'ui:title': content['veteran-id-file-number'],
      },
      ssn: {
        'ui:validations': [validations.isSsnDuplicated],
      },
    }),
    veteranServiceNumber: serviceNumberUI('Service number (if known)'),
    veteranEdipi: textUI({
      title: 'Electronic Data Interchange Personal Identifier (if known)',
      errorMessages: {
        pattern: 'Enter a valid 10-digit EDIPI',
      },
    }),
    veteranIcn: textUI({
      title: 'Integration Control Number (if known)',
      errorMessages: {
        pattern:
          'Enter a valid ICN with 10 digits, the letter V, and 6 digits. For example, 123456789V000000',
      },
    }),
  },
  schema: {
    type: 'object',
    required: ['veteranSocialSecurityNumber'],
    properties: {
      veteranSocialSecurityNumber: ssnOrVaFileNumberNoHintSchema,
      veteranServiceNumber: serviceNumberSchema,
      veteranEdipi: {
        type: 'string',
        pattern: '^\\d{10}$',
      },
      veteranIcn: {
        type: 'string',
        pattern: '^\\d{10}V\\d{6}$',
      },
    },
  },
};
